import { render, staticRenderFns } from "./GenericDiagnosticsHistoryTab.vue?vue&type=template&id=ed8def9e&scoped=true&"
import script from "./GenericDiagnosticsHistoryTab.vue?vue&type=script&lang=js&"
export * from "./GenericDiagnosticsHistoryTab.vue?vue&type=script&lang=js&"
import style0 from "./GenericDiagnosticsHistoryTab.vue?vue&type=style&index=0&id=ed8def9e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8def9e",
  null
  
)

export default component.exports